import { get, post, getApiBase } from "./ApiService";

const COMMENTS_ENDPOINT = "/comments";

export const getCommentsByBug = async (bugId) => {
  const response = await get(COMMENTS_ENDPOINT, { bug_id: bugId });
  return Array.isArray(response?.comments) ? response.comments : [];
};

export const createComment = async ({ bugId, userId, content } = {}) => {
  return post(COMMENTS_ENDPOINT, {
    bug_id: bugId,
    user_id: userId,
    content,
  });
};

export const removeComment = async ({ commentId } = {}) => {
  const body = new URLSearchParams();
  body.set("comment_id", String(commentId || "").trim());

  const response = await fetch(`${getApiBase()}${COMMENTS_ENDPOINT}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Accept: "application/json",
    },
    body: body.toString(),
  });

  const payload = await response.json().catch(() => ({
    status: "error",
    message: "Yorum silinemedi.",
  }));

  if (!response.ok || payload?.status === "error") {
    throw new Error(payload?.message || "Yorum silinemedi.");
  }

  return payload;
};
